"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const Icon_1 = __importDefault(require("@material-ui/core/Icon"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const react_2 = require("react");
require("./web.scss");
const editProps = [
    {
        name: "Twitter",
        key: "blocks.social.twitter",
        multiline: false,
        icon: "fa fa-twitter",
        editMode: false,
        ref: null,
    },
    {
        name: "Linkedin",
        key: "blocks.social.linkedin",
        multiline: false,
        icon: "fa fa-linkedin",
        editMode: false,
        ref: null,
    },
    {
        name: "Facebook",
        key: "blocks.social.facebook",
        multiline: false,
        icon: "fa fa-facebook-f",
        editMode: false,
        ref: null,
    },
    {
        name: "Website",
        key: "blocks.social.website",
        multiline: false,
        icon: "v2-globe",
        editMode: false,
        placeholder: "Enter Website URL",
        ref: null,
    }
];
const EditExpert = (props) => {
    const [socialMedias, setEditState] = react_2.useState(editProps);
    const { expert } = props;
    const onEdit = (val, key) => props.editExpert({ key, val });
    const clearData = (key) => props.editExpert({ key, val: "" });
    // open link edit mode
    const handleClick = (key) => {
        const arr = [...socialMedias];
        arr[key].editMode = true;
        setEditState(arr);
    };
    // close link edit mode
    const closeBox = (key) => {
        const arr = [...socialMedias];
        arr[key].editMode = false;
        setEditState(arr);
    };
    const handleKeyPress = (e) => {
        if (e.charCode === 13) {
            e.preventDefault();
        }
    };
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks on-the-web', square: true },
        react_1.default.createElement("h5", null, "On the Web"),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: "pt-0" }, socialMedias.map((val, key) => {
                const value = get_1.default(expert, val.key);
                val.ref = react_1.default.createRef();
                return (react_1.default.createElement(core_1.Grid, { item: true, key: key, className: "v2-row" },
                    react_1.default.createElement(core_1.Grid, { item: true, className: "web-icons" },
                        react_1.default.createElement(core_1.Grid, { item: true, className: `v2-iconBox ${value ? 'active' : ''}` },
                            react_1.default.createElement(Icon_1.default, { className: `${val.icon == "v2-globe" && value ? "v2-globe-white" : val.icon} social-icon`, color: 'primary' })),
                        react_1.default.createElement(core_1.Grid, { item: true }, val.name)),
                    react_1.default.createElement(core_1.Grid, { item: true, className: "v2-link" },
                        !val.editMode &&
                            react_1.default.createElement(react_1.Fragment, null, value ?
                                react_1.default.createElement(react_1.Fragment, null,
                                    react_1.default.createElement("span", { className: "pr-5" }, value),
                                    react_1.default.createElement(Close_1.default, { color: "disabled", className: "closeIcon", onClick: () => clearData(val.key) }))
                                : react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", className: 'v2-btn v2-btn-primary', onClick: () => handleClick(key) }, "Link")),
                        val.editMode &&
                            react_1.default.createElement(core_1.Grid, { className: 'smallBox' },
                                react_1.default.createElement("form", { noValidate: true, autoComplete: "off" },
                                    react_1.default.createElement(core_1.TextField, { inputRef: val.ref, id: "outlined-basic", label: val.placeholder ? val.placeholder : "Enter Username", variant: "outlined", type: "text", onKeyPress: (e) => handleKeyPress(e), margin: "dense" }),
                                    react_1.default.createElement(core_1.Button, { type: "button", onClick: () => {
                                            onEdit(val.ref.current.value, val.key);
                                            closeBox(key);
                                        }, color: "primary", className: "v2-btn v2-btn-primary" }, "Submit")),
                                react_1.default.createElement(Close_1.default, { color: "disabled", className: "closeIcon", onClick: () => closeBox(key) })))));
            }))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EditExpert);
